import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import DocumentTitle from 'react-document-title'
import PropTypes from 'prop-types'
import { extendObservable } from 'mobx'
import Edit from '@components/Icon/Edit'
import Action from '@components/Action'
import moment from 'moment'
import './Positions.sass'
import clone from 'lodash/clone'

class Positions extends Component {
  constructor (props) {
    super(props)

    extendObservable(this, {
      positions: []
    })
  }

  componentDidMount () {
    this.props.employeeStore.loadPositions()
  }

  renderEditPosition (position) {
    const { permissions } = this.props.employeeStore.employee
    const { modalStore } = this.props

    return (
      <Action
        onClick={() => {
          modalStore.show({
            type: 'POSITION_FORM',
            props: {
              position,
              employeePermissions: permissions
            }
          })
        }}
      >
        <Edit />
      </Action>
    )
  }

  renderDate (date) {
    return moment(date.replace('-00', '')).format('MMM-Y')
  }

  renderHourlyRate (position) {
    const { currencies } = this.props.staticData.names

    return `${position.hourlyRate / 1000000} ${currencies[position.currencyId]}`
  }

  groupContinuousPositions (employeeToPositions) {
    employeeToPositions.sort((i1, i2) => {
      if (i1.effectiveDate > i2.effectiveDate) return 1
      if (i1.effectiveDate < i2.effectiveDate) return -1
      return 0
    })

    let groupedPositions = {}
    let lastPositionId = null
    let positionGroupPrefix = 0
    let groupPrefix = ''
    let durationSinceLastEntry = 0

    const getYearFromEffectiveDate = effectiveDate =>
      parseInt(effectiveDate.substr(0, 4))
    const getMonthFromEffectiveDate = effectiveDate =>
      parseInt(effectiveDate.substr(5, 2))

    employeeToPositions.forEach((position, index) => {
      const currentMonth = getMonthFromEffectiveDate(position.effectiveDate)
      const currentYear = getYearFromEffectiveDate(position.effectiveDate)
      if (index > 0) {
        const pastEffectiveDate = employeeToPositions[index - 1].effectiveDate
        const pastMonth = getMonthFromEffectiveDate(pastEffectiveDate)
        const pastYear = getYearFromEffectiveDate(pastEffectiveDate)
        durationSinceLastEntry =
          pastMonth - currentMonth + 12 * (currentYear - pastYear)
      }

      if (
        lastPositionId !== position.employeePositionId ||
        durationSinceLastEntry !== 1
      ) {
        ++positionGroupPrefix
      }
      lastPositionId = position.employeePositionId
      groupPrefix = `${positionGroupPrefix}_${position.employeePositionId}`

      if (!position.allowedToChange) {
        if (!groupedPositions[groupPrefix]) {
          groupedPositions[groupPrefix] = []
        }

        groupedPositions[groupPrefix][index] = position
      } else {
        if (!groupedPositions[groupPrefix + '_changeable']) {
          groupedPositions[groupPrefix + '_changeable'] = []
        }
        groupedPositions[groupPrefix + '_changeable'][index] = position
      }
    })

    return Object.values(groupedPositions)
  }

  renderPositions (positions) {
    const { employeePositions } = this.props.staticData.names

    return positions.map(positionGroup => {
      positionGroup = positionGroup.filter(pos => !!pos)
      const firstPosition = clone(positionGroup).pop()
      const lastPosition = clone(positionGroup).shift()

      let date = this.renderDate(firstPosition.effectiveDate)
      if (firstPosition.effectiveDate !== lastPosition.effectiveDate) {
        date += ` / ${this.renderDate(lastPosition.effectiveDate)}`
      }

      if (!firstPosition.allowedToChange) {
        const lastPositionDescription = lastPosition.positionDescription
        const lastRole = employeePositions[lastPosition.employeePositionId]

        return (
          <div className='position-group'>
            <div>{date}</div>
            <div>{lastRole}</div>
            <div>{lastPositionDescription || '-'}</div>
            <div>{this.renderHourlyRate(lastPosition)}</div>
            <div />
          </div>
        )
      }

      return positionGroup.map(position => (
        <div className='position-group'>
          <div>{this.renderDate(position.effectiveDate)}</div>
          <div>{employeePositions[position.employeePositionId]}</div>
          <div>{position.positionDescription || '-'}</div>
          <div>{this.renderHourlyRate(position)}</div>
          <div>{this.renderEditPosition(position)}</div>
        </div>
      ))
    })
  }

  render () {
    const { positions } = this.props.employeeStore
    const positionGroups = this.groupContinuousPositions(positions)

    if (!positionGroups.length) {
      return null
    }

    return (
      <DocumentTitle title={`Employee details | Atheneum Partners`}>
        <div className='details-wrapper'>
          <div className='group-wrapper'>
            <h2>Positions</h2>
          </div>
          <div className='position-group'>
            <div>
              <h3>Effective from / to</h3>
            </div>
            <div>
              <h3>Role</h3>
            </div>
            <div>
              <h3>Description</h3>
            </div>
            <div>
              <h3>Hourly rate</h3>
            </div>
            <div />
          </div>
          {this.renderPositions(positionGroups)}
        </div>
      </DocumentTitle>
    )
  }

  static propTypes = {
    employeeStore: PropTypes.object,
    modalStore: PropTypes.object,
    staticData: PropTypes.object
  }
}

export default inject(
  'employeeStore',
  'modalStore',
  'staticData'
)(observer(Positions))
